import { Center, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TextSerif } from "@/components/elements";

const NotificationEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Center>
      <Stack gap="sm" maw="100%" w={250}>
        <Title fz="sm" ta="center">
          {t("components.NotificationMenu.empty_message")}
        </Title>
        <TextSerif fz="sm" ta="center">
          {t("components.NotificationMenu.empty_description")}
        </TextSerif>
      </Stack>
    </Center>
  );
};

export default NotificationEmptyState;
